<template>
    <Drawer class-name="aqt-drawer-box" :mask-closable="false" :closable="false" :transfer="false" inner :title="title" v-model="modalState" :mask="mask" :width="alasi" scrollable :styles="styles" ref="visibleChange">
        <div class="drawer-header" slot="header">
            <span class="aqt_lang_mn titlefont">{{ title }}</span>
            <div class="operation">
                <slot name="operation"></slot>
            </div>
            <div class="telescopic">
                <Icon type="md-code" v-if="alasi == 50" @click="telescopicClick(100)" size="25"/>
                <Icon type="md-code-working" v-if="alasi == 100" @click="telescopicClick(50)" size="25"/>
            </div>
            <div class="closable">
                <Icon type="md-close" @click="closableClick" size="25"/>
            </div>
        </div>
        <div class="aqt-drawer" v-if="modalState">
            <slot></slot>
        </div>
    </Drawer>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        mask: {
            type: Boolean,
            default: true
        },
        title: {
            type: [Number, String],
            default: '操作'
        },
        width: {
            type: [Number],
            default: 100
        }
    },
    data() {
        return {
            alasi: this.width,
            styles: {
                width: 'calc(100% - 42px)',
                height: '100%',
                overflow: 'hidden',
                paddingBottom: '10px'
            },
        }
	},
    computed: {
        modalState: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        telescopicClick (val) {
            this.alasi = val
        },
        closableClick () {
            this.$emit('closeside',false)
            this.modalState = false
        }
    },
	created() {
	},
};
</script>

<style lang="less">
.aqt-drawer-box {
    .ivu-drawer-inner {
        transition: all .5s;
    }
    overflow: hidden!important;
    .aqt-drawer {
        width: 100%;
        height: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .drawer-header {
        display: flex;
        width: 25px;
        height: auto;
        // font-size: 17px;
        color: #17233d;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        display: flex;
        align-items: center;
        padding-top: 65px;
        .closable {
            position: absolute;
            left: 0; top: 0;
            cursor: pointer;
        }
        .telescopic {
            position: absolute;
            left: 0; top: 30px;
            cursor: pointer;
        }
        .operation {
            margin-top: 10px;
            overflow: hidden;
            display: flex;
        }
    }

  //抽屉的背景色
  .ivu-drawer-content{
    background:#F5F5F5!important;
  }
  .ivu-drawer-header{
    background: #ffffff!important;
    border-right:1px solid #e8eaec!important;
    border-bottom: 0px!important;
  }
  .ivu-drawer-body{
    padding: 0!important;
  }
}

</style>

